let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jZ99Z")).then(() => parcelRequire('baqzM'));